import React from 'react';
import { Toggle } from '@app/react-common';
import { NotificationLabels } from '@bb/domain/dist/types/AppointmentConfig';
import { ExternalDashboardNotificationsDTO } from 'api/AppExternalController/getDashboardNotifications';

const NotificationGroups: NotificationLabels[] = [
  'Booked',
  'Confirmed',
  'Cancelled',
  'Deny',
  'Time Change',
  'Feedback Collected',
];

const ExternalNotificationToggles: React.FC<{
  feedbackCollectedExternal?: boolean;
  notifications?: Record<NotificationLabels, boolean>;
  toggleNotification?: (
    notification: keyof ExternalDashboardNotificationsDTO['notifications'],
  ) => void;
}> = ({ notifications, feedbackCollectedExternal, toggleNotification }) => (
  <div className="col-md-4">
    <h5>Instant Updates</h5>
    <div className="appointment-small appointment-margin-top">
      {NotificationGroups.map(notification => {
        if (
          notification === 'Feedback Collected' &&
          !notifications[notification]
        ) {
          return null;
        }
        return (
          <div
            key={notification}
            className="row"
            data-cy={`notification-settings-${notification
              .toLowerCase()
              .replace(' ', '-')}`}
          >
            <label className="col-sm-8 control-label">
              {notification === 'Booked' ? 'Requested' : notification}:
            </label>
            <div className="col-sm-4">
              <label className="control-label">
                <div className="btn-group">
                  <Toggle
                    key={notification}
                    model={
                      notification === 'Feedback Collected'
                        ? feedbackCollectedExternal
                        : notifications[notification]
                    }
                    onClick={() => toggleNotification(notification)}
                  />
                </div>
              </label>
            </div>
          </div>
        );
      })}
    </div>
  </div>
);

export default ExternalNotificationToggles;
